export default {
  currentEarlyPayment: {
    ContractNo: '',
    AmountFinanced: 0,
    OutstandingBalance: 0,
    InterestFormula: '',
    InterestRate: 0,
    InterestRateEarly: 0,
    NextDueDate: '',
    NextPeriodDate: '',
    Is5050Contract: false,
    Car: {
      CarManufacturer: '',
      Brand: '',
      YearModel: '',
      CarTypeName: '',
      ContractNo: '',
      PlateNo: '',
      Image: ''
    }
  }
}
